/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {ApexOptions} from 'apexcharts'
import ReactApexChart from 'react-apexcharts'
import {formatMonetaryToBr} from '../../../../../utils/formatMonetaryToBr'
import {IsalesByFranchises} from '../../utils/parseDashboard'
import {getChartColor} from './ChartColors'

type ChartsWidget1Props = {
  className: string
  sales: IsalesByFranchises[]
}

export const ChartSalesByFranchises: React.FC<ChartsWidget1Props> = ({className, sales}) => {
  const colors = sales.map((_, index) => getChartColor(index))

  const categories = sales.map((item) => item.name)
  const data = sales.map((item) => parseFloat(item.total_price))

  const hasData = sales.length > 0

  const options: ApexOptions = {
    chart: {
      height: 200,
      type: 'bar',
      toolbar: {
        show: false, // remove botão de download/export do gráfico se desejar
      },
    },
    grid: {
      show: false,
    },
    colors,
    plotOptions: {
      bar: {columnWidth: '30%', distributed: true, borderRadius: 6},
    },
    dataLabels: {enabled: false},
    legend: {show: false},
    xaxis: {
      categories,
      labels: {
        show: true,
        style: {
          colors,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      show: false,
    },
    tooltip: {
      y: {
        formatter: (val) => formatMonetaryToBr(val),
        title: {
          formatter: () => 'Valor vendido', // 👈 nome da série no tooltip
        },
      },
    },
  }

  return (
    <div
      className={`d-flex flex-column text-start align-items-start justify-content-start w-100 h-100 ${className}`}
    >
      {hasData ? (
        <>
          <ReactApexChart options={options} series={[{data}]} type='bar' height={200} />
        </>
      ) : (
        <div className='text-center w-100'>Nenhum dado disponível</div>
      )}
    </div>
  )
}
